export default __webpack_public_path__ + "static/media/phone_icon.7b631f58.svg";